import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getAuthHeader, getDeviceHeader } from '@/utils/helper'
import {reportApiError} from "@/utils/sentryConfig";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = getAuthHeader()
    }
    config.headers['Accept-Env'] = getDeviceHeader()

    if (process.env.NODE_ENV === 'development') {
      config.headers['route-version'] = process.env.VUE_APP_ROUTE_VERSION
    }
    return config
  },
  error => {
    // do something with request error
    // 记录请求拦截器错误到 Sentry
    reportApiError(error, error.config, null, 'request_interceptor')
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 10000) {
      switch (res.code) {
        case 20001:
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          // 上报 Token 错误到 Sentry
          reportApiError({ message: 'API Token Error: Session expired' }, response.config, response, 'token_error', res.code)
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
          break
        case 5000:
          Message({
            message: res.message || 'Tip',
            type: 'warning',
            duration: 5 * 1000
          })
          reportApiError({ message: `API Business Error: ${res.message}` }, response.config, response, 'business_error', res.code)
          break
        case 21000:
        case 21001:
        case 21002:
        case 21003:
        case 21004:
        case 21005:
        case 21006:
        case 21007:
        case 21008:
        case 21009:
        case 21010:
        case 21011:
        case 21012:
        case 21013:
        case 21014:
        case 21015:
        case 21016:
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          reportApiError({ message: `API Business Error: ${res.message}` }, response.config, response, 'business_error', res.code)
          break
        default:
          Message({
            message: 'Network abnormality, please try again',
            type: 'error',
            duration: 5 * 1000
          })
          // 上报其他未知错误到 Sentry
          reportApiError({ message: `API Unknown Error: ${res.message}` }, response.config, response, 'unknown_error', res.code)
      }

      return Promise.reject(new Error(res && res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    let status
    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (error && error.response) {
      status = error.response.status
    }
    console.log(error.response)
    switch (status) {
      case 5000:
        Message({
          message: error.message || 'Tip',
          type: 'warning',
          duration: 5 * 1000
        })
        break
      case 401:
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
        break
      case 403:
        Message({
          message: 'Unauthorized, please contact the system administrator!',
          type: 'error',
          duration: 5 * 1000
        })
        break
      case 413:
        Message({
          message: 'The uploaded file or image is too large!',
          type: 'error',
          duration: 5 * 1000
        })
        break
      default:
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
    }
    // 上报网络错误到 Sentry
    reportApiError(error, error.config, error.response, 'network_error')
    return Promise.reject(error)
  }
)

export default service
